import HomePage from './containers/HomePage'
import AboutUsPage from './containers/AboutUsPage'
import ContactPage from './containers/ContactPage'
import MenuPage from './containers/MenuPage'
import OrderPage from './containers/OrderPage'

import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'


function App() {

	const options = {
		position: 'top center',
		timeout: 3000,
		offset: '15px',
		transition: 'fade',
		containerStyle: {
		  zIndex: 10000000
		}

	}

	window.alert = function(name){
        var iframe = document.createElement("IFRAME");
        iframe.setAttribute("src", 'data:text/plain,');
        iframe.style.display="none";
        document.documentElement.appendChild(iframe);
        window.frames[0].window.alert(name);
        iframe.parentNode.removeChild(iframe);
    };


	window.confirm = function (message) {
        var iframe = document.createElement("IFRAME");
        iframe.style.display = "none";
        iframe.setAttribute("src", 'data:text/plain,');
        document.documentElement.appendChild(iframe);
        var alertFrame = window.frames[0];
        var result = alertFrame.window.confirm(message);
        iframe.parentNode.removeChild(iframe);
        return result;
    };


	return (

	<AlertProvider template={AlertTemplate} {...options}>
		<div className="App">
		    <Switch>
		    	<Route exact path="/" component={HomePage}/>
				<Route path="/about" component={AboutUsPage}/>
				<Route path="/menu" component={MenuPage}/>
				<Route path="/contact" component={ContactPage}/>
				<Route path="/order" component={OrderPage}/>

				{/* Redirects from old routes */}
				<Redirect from="/AboutUsPage" to="/about" />
				<Redirect from="/MenuPage" to="/menu" />
				<Redirect from="/ContactPage" to="/contact" />
				<Redirect from="/PleaseWaitPage" to="/" />
		    </Switch>
		</div>

	</AlertProvider>

	);
}

export default App;
